module.exports = __webpack_public_path__ + "static/media/button_sakuraadaec75b72dba1314b29fd02749ee181.webp";